import { NgModule } from '@angular/core';
import { BillingRoutingModule } from './billing-routing.module';
import { ConfigModule } from './config/config.module';

/** Freely's subscription billing — main nav, Freely and FRB profiles only. */
@NgModule({
  imports: [ConfigModule, BillingRoutingModule],
})
export class BillingModule {}
